import { render, staticRenderFns } from "./SaveBookmarkModal.vue?vue&type=template&id=57d19042&"
import script from "./SaveBookmarkModal.vue?vue&type=script&lang=js&"
export * from "./SaveBookmarkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports